import React from 'react';
import { errorCode, report } from '../utils/errors';
import AnimatedIcon from './AnimatedIcon';

/**
 * Граница ошибок React. Показывает код ошибки (по нему ошибку ищут в журнале событий на бэкенде),
 * надпись «Произошла чудовищная ошибка» и технические детали под спойлером.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, code: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error, code: errorCode() };
  }

  componentDidCatch(error, errorInfo) {
    console.error('[ErrorBoundary]', this.state.code, this.props.label || 'unknown', error, errorInfo);
    report(this.state.code, error, { label: this.props.label || '', component_stack: String(errorInfo?.componentStack || '').slice(0, 3000) });
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null, code: null });
  };

  render() {
    if (!this.state.hasError) return this.props.children;
    const { code, error } = this.state;
    return (
      <div style={{ padding: 24, textAlign: 'center', background: '#fef2f2', borderRadius: 8, margin: 8, color: 'var(--mipt-text-secondary, #555)' }}>
        <AnimatedIcon name="nuke_error" size={120} tone="danger" style={{ marginBottom: 4 }} />
        <div style={{ fontSize: 16, fontWeight: 700, color: '#991b1b', marginBottom: 4 }}>Произошла чудовищная ошибка</div>
        <div style={{ fontSize: 13, marginBottom: 10 }}>
          Код ошибки: <code style={{ fontWeight: 700, background: 'white', padding: '1px 6px', borderRadius: 4 }}>{code}</code>
          {this.props.label ? ` · ${this.props.label}` : ''}
        </div>
        <div style={{ fontSize: 12, marginBottom: 12 }}>Назовите код преподавателю — по нему в журнале видно, что именно сломалось.</div>
        <details style={{ fontSize: 11, textAlign: 'left', margin: '0 auto 12px', maxWidth: 640 }}>
          <summary style={{ cursor: 'pointer', textAlign: 'center' }}>Технические детали</summary>
          <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word', background: 'white', padding: 8, borderRadius: 6, marginTop: 6 }}>
            {String(error?.message || error || 'Неизвестная ошибка')}
          </pre>
        </details>
        <div style={{ display: 'flex', gap: 8, justifyContent: 'center' }}>
          <button onClick={this.handleReset} style={{ padding: '6px 16px', background: 'var(--mipt-blue, #004B93)', color: 'white', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 13 }}>
            Попробовать снова
          </button>
          <button onClick={() => window.location.reload()} style={{ padding: '6px 16px', background: 'white', color: 'var(--mipt-blue, #004B93)', border: '1px solid var(--mipt-blue, #004B93)', borderRadius: 6, cursor: 'pointer', fontSize: 13 }}>
            Перезагрузить страницу
          </button>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
